// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Config } from "../config";
import { ResourceDocument, ResourceSearchRequest } from "./types/search.service.types";
import {
    AssignmentsByDateQueryArgs,
    SessionDetailResourceAppointment,
} from "./types/sessionDetailTypes";

const apiManagementRootUrl: string | undefined = Config.REACT_APP_CCL_API_MANAGEMENT_URL;

// Define a service using a base URL and expected endpoints
export const cclTokenedResourceApi = createApi({
    reducerPath: "cclTokenedResourceApi",
    tagTypes: ["Resources"],
    baseQuery: fetchBaseQuery({
        baseUrl: apiManagementRootUrl,
        prepareHeaders: (headers, { getState }) => {
            //we should probably change this.
            const token = localStorage.getItem("token") as string;
            headers.set("authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        searchResources: builder.mutation<ResourceDocument[], ResourceSearchRequest>({
            query: (arg) => ({
                url: "ccl-access2/Resources/search",
                method: "POST",
                body: arg,
            }),
        }),
        getAllResources: builder.query<ResourceDocument[], void>({
            query: () => "enterprise-coaching/v1/Resources",
        }),
        getResourceByEmail: builder.query<ResourceDocument[], string>({
            query: (email) => `ccl-access2/Resources/by-email/${encodeURIComponent(email)}`,
        }),
        getResourceAssignments: builder.query<SessionDetailResourceAppointment[], number>({
            query: (imkey) =>
                `enterprise-coach-assignment/v1.0/resources/appointments/by_imkey/${imkey}`,
        }),
        getResourceAssignmentsByEmail: builder.query<SessionDetailResourceAppointment[], string>({
            query: (email) =>
                `enterprise-coach-assignment/v1.0/resources/appointments/by_email/${encodeURIComponent(
                    email
                )}`,
        }),
        getResourceAssignmentsByDate: builder.mutation<
            SessionDetailResourceAppointment[],
            Partial<AssignmentsByDateQueryArgs>
        >({
            query: (args) => ({
                url: "enterprise-coach-assignment/v1.0/resources/appointments/by_date",
                method: "POST",
                body: args,
            }),
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useSearchResourcesMutation,
    useGetAllResourcesQuery,
    useLazyGetAllResourcesQuery,
    useGetResourceByEmailQuery,
    useLazyGetResourceByEmailQuery,
    useGetResourceAssignmentsQuery,
} = cclTokenedResourceApi;
